import sdl from '@jds/react-generated-sdl/JDSFooterIconLinks';
import type { JDSFooterIconLinksProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSFooterIconLinksProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSFooterIconLinks',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FooterIconLinks = withLogic(
  Component
) as React.FC<JDSFooterIconLinksProps> & { slotName?: string };

FooterIconLinks.displayName = 'FooterIconLinks';
FooterIconLinks.slotName = 'jds_footer_icon_links';

export { FooterIconLinks, type JDSFooterIconLinksProps };
